import { call, put, delay } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadPresetsCollageBegin, loadPresetsCollageFailed, loadPresetsCollageSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadPresetsCollage(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/demo-collage`;
    yield delay(500);
    yield put(loadPresetsCollageBegin());
    const form = new FormData();
    form.set('template', action.payload);

    const dataResponse = yield makeRequest(url, form, action, 'POST', true, {}, true);
    if (dataResponse.status === OK) {
      const blob = yield dataResponse.blob();
      yield put(loadPresetsCollageSuccessful());
      yield call(resolveActionPromise(action, blob));
    } else {
      const data = yield dataResponse.json();
      yield put(loadPresetsCollageFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadPresetsCollageFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
